import { render, staticRenderFns } from "./addEditNoteCate.vue?vue&type=template&id=21b54eea&scoped=true&"
import script from "./addEditNoteCate.vue?vue&type=script&lang=js&"
export * from "./addEditNoteCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b54eea",
  null
  
)

export default component.exports